import { render } from "./EditAccountForm.vue?vue&type=template&id=0769b4b2&scoped=true"
import script from "./EditAccountForm.vue?vue&type=script&lang=js"
export * from "./EditAccountForm.vue?vue&type=script&lang=js"

import "./EditAccountForm.vue?vue&type=style&index=0&id=0769b4b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0769b4b2"]])

export default __exports__